import { styled } from '@linaria/react';
import { fonts, primitives, semantic, space } from '../../theme/tokens';
import { Badge } from '../../components/Badge';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
`;

export const PromotionBadge = styled(Badge)`
  align-self: flex-end;
`;

export const Title = styled.h1`
  font-family: ${fonts.heading};
  font-size: ${fonts.size['2xl']};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.primary};
  margin: ${space['space-200']} 0 0;
  line-height: ${primitives.typography.lineHeight.tight};
`;

export const PriceRow = styled.div`
  margin-top: ${space['space-400']};
`;

export const FieldLabel = styled.p`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
  margin: 0 0 ${space['space-300']};
`;

export const Section = styled.div`
  margin-top: ${space['space-800']};
`;

export const OptionsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(96px, 1fr));
  gap: ${space['space-300']};
`;

export const FulfilmentRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${space['space-300']};
  margin-top: ${space['space-800']};
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.secondary};
`;

export const FulfilmentItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${space['space-200']};

  svg {
    color: ${semantic.text.primary};
  }
`;

export const FulfilmentSeparator = styled.span`
  color: ${semantic.text.primary};
`;

export const DescriptionSection = styled.div`
  margin-top: ${space['space-800']};
`;

export const SpecificationsSection = styled.div`
  margin-top: ${space['space-600']};
`;
